"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import { Input, Popover } from "antd";
import moment from "moment-jalaali";
import "moment/locale/fa";
import JalaliDatePanel from "@/app/components/Common/JalaliDatePanel";
import { formatJalaliDate, normalizeJalaliDateInput, parseJalaliDate } from "@/app/utils/jalaliDate";
import { DatePickerIconIcon, GrayDatePickerIcon } from "@/app/components/UI/Icons";
moment.loadPersian({
  usePersianDigits: false
});
moment.locale("fa");
type JalaliDatePickerProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  inputClassName?: string;
  onBlur?: () => void;
  iconName?: string;
};
const datePickerIcons = {
  "date-picker-icon": DatePickerIconIcon,
  "gray-date-picker": GrayDatePickerIcon
};
const JalaliDatePicker: React.FC<JalaliDatePickerProps> = t0 => {
  const $ = _c(34);
  const {
    value,
    onChange,
    placeholder,
    inputClassName,
    onBlur,
    iconName: t1
  } = t0;
  const iconName = t1 === undefined ? "date-picker-icon" : t1;
  const [open, setOpen] = useState(false);
  const [sessionKey, setSessionKey] = useState(0);
  let t2;
  if ($[0] !== value) {
    t2 = normalizeJalaliDateInput(value);
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedValue = t2;
  let t3;
  if ($[2] !== normalizedValue) {
    t3 = parseJalaliDate(normalizedValue);
    $[2] = normalizedValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selected = t3;
  let t4;
  if ($[4] !== selected || $[5] !== value) {
    t4 = selected ? formatJalaliDate(selected) : value || "";
    $[4] = selected;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const displayValue = t4;
  const SuffixIcon = datePickerIcons[iconName as keyof typeof datePickerIcons];
  let t5;
  if ($[7] !== open) {
    t5 = nextOpen => {
      if (nextOpen && !open) {
        setSessionKey(_temp);
      }
      setOpen(nextOpen);
    };
    $[7] = open;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleOpenChange = t5;
  let t6;
  if ($[9] !== onChange) {
    t6 = (nextValue, isComplete) => {
      onChange?.(normalizeJalaliDateInput(nextValue));
      if (isComplete) {
        setOpen(false);
      }
    };
    $[9] = onChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== sessionKey || $[12] !== t6 || $[13] !== value) {
    t7 = <JalaliDatePanel key={sessionKey} value={value} onSelect={t6} />;
    $[11] = sessionKey;
    $[12] = t6;
    $[13] = value;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleOpenChange) {
    t8 = () => handleOpenChange(true);
    $[15] = handleOpenChange;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onChange) {
    t9 = event => onChange?.(normalizeJalaliDateInput(event.target.value));
    $[17] = onChange;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== SuffixIcon) {
    t10 = SuffixIcon ? <SuffixIcon className="h-6 w-6" /> : null;
    $[19] = SuffixIcon;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== displayValue || $[22] !== inputClassName || $[23] !== onBlur || $[24] !== placeholder || $[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
    t11 = <Input value={displayValue} placeholder={placeholder} onClick={t8} onChange={t9} onBlur={onBlur} suffix={t10} className={inputClassName} />;
    $[21] = displayValue;
    $[22] = inputClassName;
    $[23] = onBlur;
    $[24] = placeholder;
    $[25] = t10;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== handleOpenChange || $[30] !== open || $[31] !== t11 || $[32] !== t7) {
    t12 = <Popover content={t7} trigger="click" zIndex={1501} open={open} onOpenChange={handleOpenChange}>{t11}</Popover>;
    $[29] = handleOpenChange;
    $[30] = open;
    $[31] = t11;
    $[32] = t7;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export default JalaliDatePicker;
function _temp(key) {
  return key + 1;
}